module.exports = __webpack_public_path__ + "img/7.17dd7079.jpg";